// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class TogglerCustom extends WebComponent {
	didMount() {
		const {
			toggleClass,
			target,
			close,
		} = this.props;

		const handleClick = () => {
			this.element.classList.toggle(toggleClass);
			const targetElement = document.querySelector(target);
			targetElement.classList.toggle(toggleClass);
			const openToggles = document.querySelectorAll('.' + toggleClass);
			openToggles.forEach((toggle) => {
				if ((toggle !== this.element) && (toggle !== targetElement)) {
					toggle.classList.remove(toggleClass);
				}
			});
		};
	
		// Spustit handleClick() po načtení stránky
		if (window.innerWidth > 1199) {
			window.addEventListener('load', () => { 
				handleClick();
			});
		};
		
		// Spustit handleClick() po kliknutí na prvek
		this.element.addEventListener('click', handleClick);

		// Spustit handleClick() po kliknutí na prvek pro uzavření "close"
		document.querySelector(close).addEventListener('click', handleClick);
	  
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/TogglerCustom.js